<template>
  <div>
    <h2>欢迎登录睿赔保通管理后台，感谢您一如既往的支持！</h2>
  </div>
</template>
<script>
export default {
  name: "Home",
  async mounted() {
    // await this.$store.dispatch("user/getInfo");
  },

  methods: {
    
  },
};
</script>
<style lang="less" scoped>
h2 {
  font-weight: lighter;
}
</style>